export enum FileSideEnum {

  FRONT = "F",
  REAR = "R"

}
